import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const FADE_IN = 250;
const FADE_OUT = 300;

const css = `
.pt-cover {
  position: fixed;
  inset: 0;
  z-index: 10000;
  pointer-events: none;
  background: linear-gradient(180deg, #0d1654 0%, #1a2a7c 40%, #2a1a6c 100%);
}

.pt-fade-in {
  animation: ptFadeIn ${FADE_IN}ms ease-out forwards;
}

.pt-fade-out {
  animation: ptFadeOut ${FADE_OUT}ms ease-in forwards;
}

@keyframes ptFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes ptFadeOut {
  from { opacity: 1; }
  to   { opacity: 0; }
}
`;

let styleInjected = false;

const PageTransition = ({ children }) => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [phase, setPhase] = useState(null);
  const timerRef = useRef(null);

  if (!styleInjected && typeof document !== 'undefined') {
    const tag = document.createElement('style');
    tag.textContent = css;
    document.head.appendChild(tag);
    styleInjected = true;
  }

  useEffect(() => {
    if (location.pathname === displayLocation.pathname) return;

    setPhase('in');

    timerRef.current = setTimeout(() => {
      setDisplayLocation(location);
      window.scrollTo(0, 0);
      setPhase('out');

      timerRef.current = setTimeout(() => {
        setPhase(null);
      }, FADE_OUT);
    }, FADE_IN);

    return () => clearTimeout(timerRef.current);
  }, [location, displayLocation.pathname]);

  const cls = phase === 'in' ? 'pt-fade-in' : phase === 'out' ? 'pt-fade-out' : null;

  return (
    <>
      {children(displayLocation)}
      {cls && <div className={`pt-cover ${cls}`} />}
    </>
  );
};

export default PageTransition;
